// extracted by mini-css-extract-plugin
module.exports = {"Press":"Press_Press__1OkTR","ImgsContainer":"Press_ImgsContainer__1PI1T","PressImage":"Press_PressImage__2EsvL","PressImageSpacing":"Press_PressImageSpacing__1_baC"};